const acceptenceORcolloboration = {
  5: [
    {
      value: 3,
      label: 'In Cancellation',
    },
    {
      value: 4,
      label: 'In Collaboration',
    },
    {
      value: 5,
      label: 'Start Collab',
    },
  ],
  4: [
    {
      value: 1,
      label: 'Accepted',
    },
    {
      value: 3,
      label: 'In Cancellation',
    },
    {
      value: 4,
      label: 'In Collaboration',
    },
    {
      value: 5,
      label: 'Start Collab',
    },
  ],
  3: [
    {
      value: 2,
      label: 'Cancelled',
    },
    {
      value: 3,
      label: 'In Cancellation',
    },
    {
      value: 4,
      label: 'In Collaboration',
    },
    {
      value: 5,
      label: 'Start Collab',
    },
  ],
  2: [
    {
      value: 2,
      label: 'Cancelled',
    },
  ],
  1: [
    {
      value: 1,
      label: 'Accepted',
    },
  ],
};
export const ColloborationDropdownOptionsGroup = {
  'For Acceptance': acceptenceORcolloboration,
  'For Collaboration': acceptenceORcolloboration,
  'For Cancellation': {
    5: [
      {
        value: 3,
        label: 'In Cancellation',
      },
      {
        value: 5,
        label: 'Start Collab',
      },
    ],
    4: [
      {
        value: 4,
        label: 'In Collaboration',
      },
    ],
    3: [
      {
        value: 2,
        label: 'Cancelled',
      },
      {
        value: 3,
        label: 'In Cancellation',
      },
      {
        value: 5,
        label: 'Start Collab',
      },
    ],
    2: [
      {
        value: 2,
        label: 'Cancelled',
      },
    ],
    1: [
      {
        value: 1,
        label: 'Accepted',
      },
    ],
  },
  'Waiting for MoB Decision': {
    5: [
      {
        value: 5,
        label: 'Start Collab',
      },
    ],
    4: [],
    3: [],
    2: [],
    1: [],
  },
};
